import request from 'superagent';
import * as types from 'constants/ActionTypes';
import { SNIPLETS_URL } from 'constants/Jaws';

function requestData() {
  return { type: types.REQUEST_SNIPLETS };
}

function receiveData(data) {
  return { type: types.RECEIVE_SNIPLETS, data };
}

function updateSniplet(data) {
  return { type: types.UPDATE_SNIPLET, data };
}

export function fetchData() {
  return dispatch => {
    dispatch(requestData());
    request.get(`${SNIPLETS_URL}`).end((err, res) => {
      if (err) throw new Error(err);

      dispatch(receiveData(res.body.data));
    });
  };
}

export function fetchSniplet(id) {
  return dispatch => {
    request.get(`${SNIPLETS_URL}/${id}`).end((err, res) => {
      if (err) throw new Error(err);

      dispatch(updateSniplet(res.body.data));
    });
  };
}

export function editSniplet(sniplet, callback) {
  return dispatch => {
    request
      .put(`${SNIPLETS_URL}/${sniplet.id}`)
      .send({ data: sniplet })
      .end((err, res) => {
        if (err) throw new Error(err);

        dispatch(updateSniplet(res.body.data));

        if (callback) callback();
      });
  };
}
